import React, { useState } from 'react';

import { observer } from "mobx-react-lite/dist/observer";
import { useStore } from "../../../app/stores/store";
import { useHistory } from "react-router-dom";
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import questionIco from '../src/imgs/question_ico.svg';
import { Icon } from 'semantic-ui-react';

import ModalRegionalOff from '../Handlers/RegionModalOff';
import "../src/css/modal_region.css";

import modalRCentral from '../src/imgs/regional_images/central/home_modal_central.jpg';
import modalRPeten from '../src/imgs/regional_images/peten/home_modal_peten.jpg';
import modalNextA from '../src/imgs/next_arrow.png';

export const Botonera = () => { 

  // function refreshPage() {
  //   window.location.reload(false);
  // }

  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  // const history = useHistory();

  // const petenChange = () => {
  //     let path = `/peten/`;
  //     history.push(path);
  // }

  // const centralChange = () => {
  //     let path = `/`;
  //     history.push(path);
  // }

  // function refreshChange() {
  //   window.location.reload();
  // }

  // function hacerPeten(){
  //   petenChange(); refreshChange();
  // }

  // function hacerCentral(){
  //   centralChange(); refreshChange();
  // }
  
  return (
    <>
      <div id="portafolio_home_botonera" className="portafolio_home_botonera">
        
          <Button
              target="_blank" 
              variant="primary"
              href='https://inap.gob.gt/web/wp-content/uploads/2021/11/AGENDA-DE-SERVICIOS-PARA-EL-FORTALECIMIENTO-INSTITUCIONAL-2025.pdf'
              // href="https://inap.gob.gt/web/wp-content/uploads/2021/11/ULTIMA-VERSION-AGENDA-WEB-140-02-2022.pdf"
              >Descargar agenda 2025
          </Button>

          <div className="faqs_sec">
            <a href="/app/preguntas_frecuentes">
              <img src={ questionIco }/>
              <p>Preguntas frecuentes</p>
            </a>
          </div>
      </div>

      {/* <Modal
        show={show}
        onHide={handleClose}
        // backdrop="static"
        keyboard={false}
        centered
        size="lg"
        id="home_modal_raiz"
        bsPrefix="modal backHome"
      >
        <Modal.Body>

          <div className="container home_modal">
            <div className="row">
              
              <div className="col-md-6 col-xs-12 modal-izq" onClick={hacerCentral} style={{ backgroundImage: `url(${modalRCentral})` }} >
                <div className="izq-container" onClick={() => window.location.reload()}>
                  <h3>Cursos<br></br>INAP&nbsp; Central</h3>
                  <p>Ingresa para ver cursos.</p>
                  <img className="modalNextI" src={modalNextA} />
                </div>
              </div>

              <div className="col-md-6 col-xs-12 modal-dre" onClick={hacerPeten} style={{ backgroundImage: `url(${modalRPeten})` }}>
                <div className="dre-container" >
                  <h3>Cursos<br></br>Delegación&nbsp; Petén</h3>
                  <p>Ingresa para ver cursos exclusivos pára la región de Petén.</p>
                  <img className="modalNext" src={modalNextA} />
                </div>
              </div>

            </div>
          </div>

        </Modal.Body>

      </Modal> */}
    </>
  )
}
